import clsx from 'clsx';
import React, { useState } from 'react';
import ReactHtmlParser from 'react-html-parser';

import useEventTracking from '@hooks/useEventTracking';
import { TrackingLocation } from '@tracking';

import SearchBar from '../Organization/UsersSection/UserTypes/SearchBar';
import OrgChartsHeaderPaywall from './HeaderPaywall';
import { OrgChartsContentHeaderProps } from './interfaces';

const OrgChartsContentHeader = ({
  title,
  description,
  onSearchTermChange,
  user,
}: OrgChartsContentHeaderProps) => {
  const { Track } = useEventTracking({
    location: TrackingLocation.OrgChartSearchBar,
  });

  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchTermChange = (searchTerm: string) => {
    setSearchTerm(searchTerm);
    onSearchTermChange(searchTerm);
  };

  const shouldShowSearchBar = user?.is_pro_subscriber;
  const shouldShowPaywall = !user || !user.is_pro_subscriber;

  return (
    <div className="mx-auto mb-32 flex max-w-[850px] flex-col items-center">
      <h1 className="my-0 text-headline-alt-xl">{title}</h1>
      <div
        className={clsx('m-0 pt-0 font-suisse-neue text-subheadline-sm', {
          'pb-32': shouldShowSearchBar, //mutually exclusive with the shouldShow
          'pb-64': shouldShowPaywall,
        })}
      >
        {description && (
          <div className="font-suisse-neue text-subheadline-sm">{ReactHtmlParser(description)}</div>
        )}
      </div>
      {shouldShowSearchBar && (
        <Track>
          <SearchBar
            searchTerm={searchTerm}
            setSearchTerm={handleSearchTermChange}
            placeholder="Search for a company"
          />
        </Track>
      )}
      {shouldShowPaywall && (
        <div
          className="-ml-60 -mb-32 w-screen bg-grayscale-charcoal dark:bg-[var(--light-grayscale-charcoal)]"
          data-testid="paywall"
        >
          <OrgChartsHeaderPaywall shouldShowPaywall={shouldShowPaywall} currentUser={user} />
        </div>
      )}
    </div>
  );
};

export default OrgChartsContentHeader;
